import { logger } from '../../../util/logger';
export class MediaBuilder {
    constructor(trackProvider, roomWall) {
        this.trackProvider = trackProvider;
        this.roomWall = roomWall;
        this.log = logger.extend('sdk:media_builder');
    }
    async createMedia(config) {
        const result = await this.trackProvider.createMediaStream(config);
        if (result.audio) {
            this.roomWall.addOrUpdate(this.roomWall.builder.buildTrackWallItem('audioTrack', {
                active: null,
                name: config.audio?.name,
            }));
            this.log.info(`Media of type audio created with name: ${config.audio?.name}`);
        }
        if (result.video) {
            this.roomWall.addOrUpdate(this.roomWall.builder.buildTrackWallItem('videoTrack', {
                cameraSubject: config.video?.cameraSubject,
                name: config.video?.name,
                active: config.video?.active,
            }));
            this.log.info(`Media of type video created with name: ${config.video?.name}`);
        }
        if (result.data) {
            this.roomWall.addOrUpdate(this.roomWall.builder.buildTrackWallItem('dataTrack', {
                name: config.data?.name,
            }));
            this.log.info(`Media of type data created with name: ${config.data?.name}`);
        }
    }
}
//# sourceMappingURL=media_builder.js.map